import clsx from 'clsx';
import React from 'react';
import { responsiveCssProperties } from '../../utils';
import { VisuallyHidden } from '../VisuallyHidden';
import { Box } from '../Box';
export function DetailListItem(props) {
    const { children, className, label, description, value, prefix, postfix, action, alignItems, ...rest } = props;
    return (React.createElement(Box.Restricted, { ...rest, elementType: "tr", className: clsx('mollie-ui-detail-list-item', className), style: responsiveCssProperties('--mollie-ui-detail-list-item-align-items', alignItems), role: "row" },
        prefix && (React.createElement("td", { role: "cell", className: "mollie-ui-detail-list-cell mollie-ui-detail-list-prefix" }, prefix)),
        label && (React.createElement("th", { role: "rowheader", scope: "row", className: "mollie-ui-detail-list-cell mollie-ui-detail-list-label" },
            React.createElement("div", null, label),
            description && (React.createElement(Box, { className: "mollie-ui-detail-list-description", UNSAFE_hideWhenEmpty: true, "aria-hidden": true }, description)))),
        description && (React.createElement(VisuallyHidden, { elementType: "td", role: "cell" }, description)),
        (value || children) && (React.createElement("td", { role: "cell", className: clsx('mollie-ui-detail-list-cell', {
                'mollie-ui-detail-list-value': !!label,
            }) },
            value,
            children)),
        postfix && (React.createElement("td", { role: "cell", className: "mollie-ui-detail-list-cell mollie-ui-detail-list-postfix" }, postfix)),
        action && (React.createElement("td", { role: "cell", className: "mollie-ui-detail-list-cell mollie-ui-detail-list-action" }, action))));
}
DetailListItem.displayName = 'DetailList.Item';
//# sourceMappingURL=DetailListItem.js.map